module.exports = __webpack_public_path__ + "img/contact.b7b064ca.png";